module.exports = __webpack_public_path__ + "static/img/jerusalem.0501faf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/jerusalem.jpg
// module id = Yi4A
// module chunks = 6